import React from 'react';
import {IDiplomatObject} from 'types/DiplomatObject';
import {pageActions} from '..';
import {useDispatch} from 'react-redux';
import {FormOnSubmitHelpers} from 'components/hook-form/Formik';

export const useSendData = () => {
   const dispatch = useDispatch();

   const send = React.useCallback(
      (dialog: string, data: IDiplomatObject, cbs?: FormOnSubmitHelpers<IDiplomatObject>) => {
         dispatch(pageActions.sendData(dialog, data, cbs));
      },
      [dispatch]
   );

   return send;
};
